// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { setPage } from "../../actions";
import { connect } from "react-redux";
// Svg icons imports
import { ReactComponent as BookSvg } from '../../svg-icons/book.svg';
import { ReactComponent as ChartSquareSvg } from '../../svg-icons/chart-square.svg';
import { ReactComponent as TokenCoinSvg } from '../../svg-icons/token-coin.svg';
import { ReactComponent as WalletMoneySvg } from '../../svg-icons/wallet-money.svg';
import { ReactComponent as ClockSvg } from '../../svg-icons/clock.svg';
import { ReactComponent as ShoppingCartSvg } from '../../svg-icons/shopping-cart.svg';
import { ReactComponent as DirectUpSvg } from '../../svg-icons/arrow-up.svg';
// Styles imports
import './TokenAnalyzerStatItem.css';
import '../../util.css'
// Consts imports
import {
    RED,
    ORANGE,
    YELLOW,
    EMERALD,
    GREEN,
    LEVEL_FEATURES,
    PAGE_UPGRADE,
    TOKEN_NAME,
    TOKEN_WALLETS,
    TOKEN_TRANSACTIONS,
    TOKEN_TRADES,
    TOKEN_AVERAGE_TRADE_TIME,
    TOKEN_AVERAGE_BUY_VOLUME
} from "../../consts/consts";

function AvailableTitle(props) {

    const { level } = props;
    return (
        <span className={"check-wallet__stats-item__block_text_available "}>
            Upgrade to <br/>AI level {level}
        </span>
    );

}

function Title(props) {

    const { type } = props;

    let title = null

    if (type === TOKEN_NAME) {
        title = "Token"
    } else if (type === TOKEN_TRANSACTIONS) {
        title = "Transactions"
    } else if (type === TOKEN_WALLETS) {
        title = "Wallets"
    } else if (type === TOKEN_TRADES) {
        title = "Trades"
    } else if (type === TOKEN_AVERAGE_TRADE_TIME) {
        title = "Average trade time"
    } else if (type === TOKEN_AVERAGE_BUY_VOLUME) {
        title = "Average buy volume"
    } else {
        return null
    }

    return (
        <span className={"token-analyzer__stats-item__block token-analyzer__stats-item__block_text "}>
            {title}
        </span>
    );

}

function Indicator(props) {

    const { indicator } = props;

    let indicatorStyle = ""

    if (indicator === RED) {
        indicatorStyle = "token-analyzer__stats-item__item-indicator_red"
    } else if (indicator === ORANGE) {
        indicatorStyle = "token-analyzer__stats-item__item-indicator_orange"
    } else if (indicator === YELLOW) {
        indicatorStyle = "token-analyzer__stats-item__item-indicator_yellow"
    } else if (indicator === EMERALD) {
        indicatorStyle = "token-analyzer__stats-item__item-indicator_emerald"
    } else if (indicator === GREEN) {
        indicatorStyle = "token-analyzer__stats-item__item-indicator_green"
    } else {
        return null
    }

    return (
        <div className={"token-analyzer__stats-item__item-indicator " + indicatorStyle}></div>
    );

}

function Stat(props) {

    const { stat } = props;

    return (
        <span className={"token-analyzer__stats-item__block token-analyzer__stats-item__main-stat"}>
            {stat}
        </span>
    );

}

function Description(props) {

    const { firstDescription, secondDescription } = props;

    return (
        <span className={"token-analyzer__stats-item__block"}>
            {firstDescription}<br/>{secondDescription}
        </span>
    );

}

function Icon(props) {

    const { type } = props;

    if (type === TOKEN_NAME) {
        return (<TokenCoinSvg className={"token-analyzer-stats-block-item-icon"}/>);
    } else if (type === TOKEN_WALLETS) {
        return (<WalletMoneySvg className={"token-analyzer-stats-block-item-icon"}/>);
    } else if (type === TOKEN_TRANSACTIONS) {
        return (<BookSvg className={"token-analyzer-stats-block-item-icon"}/>);
    } else if (type === TOKEN_TRADES) {
        return (<ChartSquareSvg className={"token-analyzer-stats-block-item-icon"}/>);
    } else if (type === TOKEN_AVERAGE_TRADE_TIME) {
        return (<ClockSvg className={"token-analyzer-stats-block-item-icon"}/>);
    } else if (type === TOKEN_AVERAGE_BUY_VOLUME) {
        return (<ShoppingCartSvg className={"token-analyzer-stats-block-item-icon"}/>);
    } else {
        return null
    }

}

class TokenAnalyzerStatItem extends React.Component {

    constructor(props) {
        super(props);
    }

    handleUpgradeClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_UPGRADE);
    };

    render () {
        const {type, indicator, stat, firstDescription, secondDescription, aiLevel} = this.props;

        if ( aiLevel < LEVEL_FEATURES[type]) {
            return(
                <div className={"check-wallet__stats-item-available"} onClick={this.handleUpgradeClick}>
                    <DirectUpSvg className={"check-wallet-stats-block-item-icon-direct-up"}/>
                    <AvailableTitle level={LEVEL_FEATURES[type]}/>
                </div>
            );
        }

        return(
            <div className={"token-analyzer__stats-item"}>
                <Indicator indicator={indicator}/>
                <Title type={type}/>
                <Stat stat={stat}/>
                <Description firstDescription={firstDescription} secondDescription={secondDescription}/>
                <Icon type={type}/>
            </div>
        );
    }

}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setPage,
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(TokenAnalyzerStatItem);